import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const LoaderWrapper = styled.div`
  display: inline-block;
  width: 50px;
  height: 50px;

  &:after {
    content: ' ';
    display: block;
    width: 32px;
    height: 32px;
    margin: 8px;
    border-radius: 50%;
    border: 3px solid var(--primary500-color, #000);
    border-color: var(--primary500-color, #000) transparent
      var(--primary500-color, #000) transparent;
    animation: ${spin} 1.2s linear infinite;
  }
`

export const Loader = () => {
  return <LoaderWrapper />
}
